export default {
  AUD: "$",
  EUR: "€",
  GBP: "£",
  USD: "$",
};



// WEBPACK FOOTER //
// ./assets/shared/utils/currencySymbol.js